import axios from "axios";
import Errores from "@/utils/Errores";
//import Datos from "@/assets/js/resultado";

let validarComprobante = async (authentication, componente) => {
  let url = API.POSTULACION;
  let postulacion = await axios
    .get(url + "v1/private/postulaciones/validar", {
      headers: {
        Authorization: "Bearer " + authentication
      }
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      if (error.response) {
        if (error.response.status !== 404) {
          Errores.switchErrors(error, componente);
        }
      } else {
        Errores.switchErrors(error, componente);
      }
      return null;
    });
  return postulacion;
};

//let validarComprobantePrueba = async () => {
//  return Datos.datos;
//}

export default {
  validarComprobante
  //  validarComprobantePrueba
};



// WEBPACK FOOTER //
// ./src/service/ApiComprobante.js